export default __webpack_public_path__ + "static/PromptIconFive-84a8af8af1c9386e0245b24017604ca4.png";